import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Flex, Box } from "@chakra-ui/react";
import { FilterQuotationProps, IFilterQuotation } from "./interface";
import FieldSearch from "../FieldSearch";
import { getQuotationStatusName } from "../../helpers/global";
import CustomReactSelect from "../CustomReactSelect";
import { QuotationStatus } from "../../generated/graphql";
import DateRangePicker from "../DateRangePicker";
import { getThisYear } from "../DateRangePicker/data";

const statuses = [
  {
    label: getQuotationStatusName(QuotationStatus.Hold),
    value: QuotationStatus.Hold,
  },
  {
    label: getQuotationStatusName(QuotationStatus.Confirmed),
    value: QuotationStatus.Confirmed,
  },
  {
    label: getQuotationStatusName(QuotationStatus.Canceled),
    value: QuotationStatus.Canceled,
  },
];

const Filter: React.FC<FilterQuotationProps> = ({ onSubmit, value }) => {
  const { handleSubmit, setValue, control } = useForm<IFilterQuotation>({
    defaultValues: {
      dateRange: getThisYear(),
    },
  });

  useEffect(() => {
    setValue("key", value?.key || "");
    setValue("status", value?.status);
    setValue("dateRange", value?.dateRange);
  }, [value, setValue]);

  return (
    <form onSubmit={(e) => e.preventDefault()} autoComplete="off">
      <Box mb={2}>
        <Controller
          control={control}
          name="dateRange"
          render={({ field: { onChange, value } }) => (
            <DateRangePicker
              value={value}
              onSubmit={(e) => {
                onChange(e);
                handleSubmit(onSubmit)();
              }}
            />
          )}
        />
      </Box>
      <Flex alignItems="center" gap={4}>
        <Box>
          <Controller
            name="key"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FieldSearch
                placeholder="Search Booking Code"
                value={value}
                onChange={(e) => {
                  onChange(e);
                  handleSubmit(onSubmit)();
                }}
              />
            )}
          />
        </Box>
        <Box>
          <Controller
            name="status"
            control={control}
            render={({ field: { value } }) => (
              <CustomReactSelect
                placeholder="All Status"
                size="sm"
                value={statuses.find((elm) => elm.value === value)}
                options={statuses}
                onChange={(value) => {
                  setValue("status", value?.value as QuotationStatus);
                  handleSubmit(onSubmit)();
                }}
                isSearchable={false}
                isClearable
              />
            )}
          />
        </Box>
      </Flex>
    </form>
  );
};

export default Filter;
